import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M71.125 39.531H9.375a2.346 2.346 0 0 0-2.344 2.344v35.75a2.346 2.346 0 0 0 2.344 2.344h61.75a2.346 2.346 0 0 0 2.344-2.344v-35.75a2.346 2.346 0 0 0-2.344-2.344m-2.344 35.75H11.72V44.219h57.062zM83.22 32.125v35.75a2.345 2.345 0 0 1-4.688 0V34.469H19.127a2.345 2.345 0 0 1 0-4.688h61.75a2.346 2.346 0 0 1 2.343 2.344zm9.75-9.75v35.75a2.345 2.345 0 0 1-4.688 0V24.719H28.877a2.345 2.345 0 0 1 0-4.688h61.75a2.346 2.346 0 0 1 2.343 2.344z" }, null, -1)
  ])))
}
export default { render: render }